import React from "react";
import { ButtonToolbar, Button, Form, Image, Row } from "react-bootstrap";
import uparrow from "../../assets/uparrowsvg.svg";
import TooltipComponent from "../../component/TooltipComponent";
import InfoIcon from "../../assets/small-info-icon.svg";
import CircleWithExclamation from "../../assets/circle-with-exclamation.svg";
import { Field } from "../../component/FieldComponent";
import IconPin from "../../assets/icon-pin.png";
import { handleLanguage, handlePaste } from "../../helper";
import { modifyDataForPost } from "./helper";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux/es/redux";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  setIssueStatusAction,
  postCommentAction,
  replyAction,
  issueClarificationAction
} from "../../actions/issuesListAction.actions";
import {
  ERROR_MSG,
  FILE_FORMATS,
  STATUS,
  MAX_CHARACTER_LIMIT
} from "../../constant";
import {
  UploadAttachmentsWithTitleComponent,
  DisplayAttachments
} from "../reusableComponent";
import { get, isFunction } from "lodash";
import { successToastStyle, errorToastStyle } from "../../customToast";
export class IssueEditButton extends React.Component {
  constructor() {
    super();
    this.state = {
      showEdit: false,
      action: "",
      files: [],
      showAddDecisionConfirmationModal: false,
      agendasAssociatedWithIssue: [],
      checkAgenda: true,
      canUploadVideo: true,
      languageError: null,
      pasteError: false,
      pastedText: ""
    };
  }
  onShow = () => {
    this.setState(prevState => ({
      showEdit: !prevState.showEdit
    }));
  };
  onToggleAttachment = index => {
    this.setState(prevState => {
      return {
        toggleAttachementDisplay: !prevState.toggleAttachementDisplay
      };
    });
  };
  onChange = (value, key) => {
    this.setState({ [key]: value }, () => {
      if (window.event.inputType === "insertFromPaste") {
        this.pasteLanguage();
      }
    });
    if (key === "comment") {
      if (value.length > MAX_CHARACTER_LIMIT) {
        value = value.slice(0, MAX_CHARACTER_LIMIT);
      }
    }
  };
  onError = (value, key) => {
    this.setState(prevState => ({
      error: {
        ...prevState.error,
        [key]: value
      }
    }));
  };
  inputLanguage = event => {
    if (window.event.inputType !== "insertFromPaste") {
      let hasInputValue = handleLanguage(event);
      this.setState({
        languageError: hasInputValue,
        pasteError: false
      });
    }
  };
  onBlur = value => {};
  pasteLanguage = () => {
    let { filterString, hasBadValue } = handlePaste(this.state.comment);
    if (hasBadValue === true) {
      this.setState({
        pasteError: hasBadValue,
        comment: filterString
      });
    }
  };
  onPostComment = () => {
    const {
      issueDetails: { id },
      postCommentDispatch,
      callApiOnSuccess
    } = this.props;
    const { files, comment } = this.state;

    // error
    if (comment === undefined || !comment.trim() || comment === "") {
      this.setState(prevState => ({
        languageError: false,
        pasteError: false,
        error: {
          ...prevState.error,
          comment: {
            error: comment === undefined || !comment.trim() || comment === "",
            message:
              comment === undefined || !comment.trim() || comment === ""
                ? ERROR_MSG.DEFAULT_MSG
                : ""
          }
        }
      }));
    } else {
      const modifyData = modifyDataForPost({ files, comment, id });
      this.setState(
        {
          isCommentLoading: STATUS.LOADING
        },
        async () => {
          const resp = await postCommentDispatch(undefined, modifyData);
          if (resp) {
            const { status, message } = resp;
            (status &&
              toast.success(
                <p className="toast-text-alignment">{message}</p>,
                successToastStyle
              )) ||
              toast.error(
                <p className="toast-text-alignment">{message}</p>,
                errorToastStyle
              );
            isFunction(callApiOnSuccess) && callApiOnSuccess();
            this.setState(
              prevState => ({
                isCommentLoading: (status && STATUS.SUCCESS) || STATUS.ERROR,
                comment: "",
                files: [],
                reset: true,
                error: {
                  ...prevState.error,
                  comment: {}
                }
              }),
              () => {
                this.setState({
                  reset: false
                });
              }
            );
          } else {
            toast.error(
              <p className="toast-text-alignment">
                {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
              </p>,
              errorToastStyle
            );
          }
        }
      );
    }
  };
  render() {
    const {
      action,
      comment,
      error,
      files,
      actionType,
      isProjectVerifing,
      isCommentLoading,
      imageStatus,
      toggleAttachementDisplay,
      canUploadVideo,
      pasteError,
      languageError
    } = this.state;
    return (
      <>
        <Button
          className={`new-updatestatus-btn no-padding shadow-none align-self-end`}
          onClick={this.onShow}
        >
          Update Status <img className="uparrowicon" src={uparrow} />
        </Button>
        <div>
          <div className="d-flex update-comment-tooltip">
            <div className="update-heading">Update Status/Comment</div>
            <TooltipComponent
              classes="add_issue_tooltip"
              smallIconInfo={InfoIcon}
              placement="right"
              content={
                <>
                  Latest update, indicate latest pendency in values, for eg:{" "}
                  <br /> pending/total (km, Ha, units, etc), efforts undertaken
                  to resolve <br /> issue, timeline for completing pending tasks
                  (if any).
                </>
              }
            />
          </div>
          <Form.Group
            controlId="exampleForm.ControlTextarea1"
            className={`comment-area issue-detail-actions ${
              languageError === true || (pasteError === true && comment !== "")
                ? "language-error-border-alert"
                : ""
            }`}
          >
            <Field
              as="textarea"
              keyName="comment"
              rows="3"
              value={comment}
              className="add-comment"
              maxLength="500"
              placeholder="Latest update, indicate latest pendency in values, for eg: pending/total (km, Ha, units, etc), efforts undertaken to resolve issue, timeline for completing pending tasks (if any)."
              onInput={this.inputLanguage}
              onChange={this.onChange.bind(this)}
              onError={this.onError.bind(this)}
              isInvalid={get(error, "comment.error")}
              onBlur={this.onBlur}
            />
            {toggleAttachementDisplay ? (
              <UploadAttachmentsWithTitleComponent
                displayModal={toggleAttachementDisplay}
                onCloseModal={this.onToggleAttachment}
                fileFormats={FILE_FORMATS}
                onSubmit={this.onSuccessUploadOfAttachmets}
                canUploadVideo={canUploadVideo}
              />
            ) : null}
            <Form.Control.Feedback type="invalid">
              {languageError === true || (pasteError === true && comment !== "")
                ? ""
                : get(error, "comment.message")}
            </Form.Control.Feedback>
          </Form.Group>
          <Row className="align-action justify-content-between">
            <span className="remaining-char">
              Remaining characters :{" "}
              {comment
                ? MAX_CHARACTER_LIMIT - comment.length
                : MAX_CHARACTER_LIMIT}
            </span>
            {languageError || (pasteError && comment !== "") ? (
              <div className="warning">
                <Image src={CircleWithExclamation} />
                Only English language is supported.
              </div>
            ) : (
              <></>
            )}
          </Row>
          <Form.Group className="field-attachment issue-detail-action">
            <div className="attachment-box">
              <DisplayAttachments
                filesArr={files}
                onRemoveFile={this.onRemoveFile}
                addAttchementRequired={false}
                classes="attachments"
              />
              <div className="add-attachment" onClick={this.onToggleAttachment}>
                <div className="add-attachment-button">
                  <Image src={IconPin} alt="Attachment Icon" />
                  Add Attachment
                </div>
              </div>
            </div>
            <div className="button-group post-comment">
              <Button
                className="btn-orange-invert btn-small print-btn post-btn"
                onClick={this.onPostComment}
              >
                <div className="post-icon orange" />
                Add Comment
              </Button>
            </div>
          </Form.Group>
        </div>
      </>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      postCommentDispatch: postCommentAction,
      setIssueStatusDispatch: setIssueStatusAction,
      postCommentDispatch: postCommentAction,
      // getIssueListDispatch: getIssueList,
      replyActionDispatch: replyAction,
      issueClarificationDispatch: issueClarificationAction
      // getIssueMeetingByIdDispatch: getIssueMeetingByIdAction,
      // getIssueDetailsDispatch: getIssueDetails,
      // getProjectDetails,
      // unHoldIssueAction
    },
    dispatch
  );
}

export default withRouter(
  connect(
    mapDispatchToProps,
    mapDispatchToProps
  )(IssueEditButton)
);
